import {UI} from "../../../../../stem-core/ui/UIBase";
import {DateCalendarInputInterface} from "../base/DateCalendarInputInterface";
import {DateCalendarMonthInput} from "./DateCalendarMonthInput";
import {StemDate} from "../../../../../stem-core/time/Date";


export class DateCalendarInput extends DateCalendarInputInterface {
    referenceTime = new StemDate();

    setValue(value: StemDate) {
        super.setValue(value);
        this.referenceTime = value;
        this.swipe(this.referenceTime);
    }

    renderCalendarMonthComponent(monthDate: StemDate) {
        const {minDate, maxDate} = this.options;

        return <DateCalendarMonthInput
            initialValue={this.value}
            onChange={value => this.setAndDispatchValue(value)}
            {...{minDate, maxDate, monthDate}}
        />;
    }
}
